module.exports = __webpack_public_path__ + "static/media/geant.45fff3a4.svg";